import {
  ConfigurationCanvasPanelProps,
  ConfigurationCanvasPanel,
} from './ConfigurationCanvasPanel';
import { slideFromRight } from '../../animations/cssAnimations';

export const ConfigurationCanvasRightPanel: React.FC<ConfigurationCanvasPanelProps> = (props) => {
  const _width = props.width ?? 800;
  return (
    <ConfigurationCanvasPanel
      positionSx={{
        position: 'absolute',
        top: 0,
        left: 'auto',
        right: 0,
        ...slideFromRight,
      }}
      width={_width}
      {...props}
    />
  );
};
